<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết phiếu luân chuyển thiết bị</h1>
      <div class="float-right">
        <button
          type="button"
          class="font-medium f12 btn btn-outline-secondary m-r-10"
          @click="$router.push('/customer-support/order-contract')"
        >
          <b-icon icon="arrow-left" aria-hidden="true" />
          Quay lại
        </button>
      </div>
      <hr />
    </div>
    <div class="p-10 card pt-15">
      <div class="card-header m-b-10"></div>
      <!-- Hiển thị dữ liệu -->
      <b-row>
        <b-col cols="6" md="6">
          <DetailInfo :info="infoData" :isLoading="isLoading" :fields="keyNames">
            <template #status="{ value }">
              <span :class="`badge ${getStatusObj(value)?.bgColor}`">
                {{ getStatusObj(value)?.text }}
              </span>
            </template>

            <template #contractType="{ value }">
              <span>
                {{ value | transformData(Config?.typeAppendix) }}
              </span>
            </template>
            <template #createdDate="{ value }">
              <span>
                {{ value | formatDate('HH:mm DD/MM/YYYY') }}
              </span>
            </template>
            <template #dateCreateContract="{ value }">
              <span>
                {{ value | formatDate('HH:mm DD/MM/YYYY') }}
              </span>
            </template>
            <template #dateApprove="{ value }">
              <span v-if="infoData?.status === 'COMPLETED'">
                {{ value | formatDate('HH:mm DD/MM/YYYY') }}
              </span>
              <span v-if="infoData?.status === 'CANCEL'">
                {{ infoData?.dateCancel | formatDate('HH:mm DD/MM/YYYY') }}
              </span>
            </template>
            <template #approveByName="{ value }">
              <span>
                {{ value || infoData?.cancelByName }}
              </span>
            </template>
            <template #reason="{ value }">
              <span>
                {{ getReason(value).text }}
              </span>
            </template>

            <template #sender="{ value }">
              <div>
                <span>
                  {{ getSenderTypeText(value?.type) }}
                </span>
              </div>
              <div>
                <span>
                  {{ value?.name }}
                </span>
              </div>
              <div>
                <b-link :href="`mailto:${value?.email}`" class="text-primary">
                  {{ value?.email }}
                </b-link>
              </div>
            </template>
            <template #receiver="{ value }">
              <div>
                <span>
                  {{ getSenderTypeText(value?.type) }}
                </span>
              </div>
              <div>
                <span>
                  {{ value?.name }}
                </span>
              </div>
              <div>
                <b-link :href="`mailto:${value?.email}`" class="text-primary">
                  {{ value?.email }}
                </b-link>
              </div>
            </template>
          </DetailInfo>
        </b-col>
        <b-col cols="6" md="6">
          <div class="form-detail history">
            <h1 style="border-bottom: none">
              <strong class="h1-strong">Lịch sử lên phụ lục thiết bị</strong>
            </h1>

            <b-table
              :busy.sync="isLoading"
              head-variant="light"
              sticky-header
              hover
              responsive
              :items="listHistory"
              :fields="fieldsTableHistory"
              selectable
              show-empty
              select-mode="single"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
              <template #cell(dateTime)="{ item }">
                <span>
                  {{ item?.timeCreate | formatDate('HH:mm DD/MM/YYYY') }}
                </span>
              </template>
              <template #cell(action)="{ item }">
                <div>
                  <span :class="`badge ${getStatusObj(item?.action)?.bgColor}`">
                    {{ getStatusObj(item?.action)?.text }}
                  </span>
                </div>
              </template>
              <template #cell(serialDevice)="{ item }">
                <div>
                  <p>{{ item?.serialDevice }}</p>
                  <p>{{ item?.mobileUserStr }}</p>
                </div>
              </template>

              <template #cell(user)="{ item }">
                <div>
                  <p>
                    {{ item?.namePerformer }}
                  </p>
                  <b-link :href="`mailto:${item?.emailPerformer}`">
                    {{ item?.emailPerformer }}
                  </b-link>
                </div>
              </template>
            </b-table>
          </div>
        </b-col>
        <b-col cols="12" md="12">
          <div class="form-detail">
            <h1 style="border-bottom: none">
              <strong class="h1-strong">Danh sách thiết bị</strong>
            </h1>
            <div class="d-flex flex-row">
              <div class="box-header list_total">
                <TotalCountCheck :totals="totalCount" :data="[]"></TotalCountCheck>
              </div>
            </div>
            <b-table
              :busy.sync="isLoading"
              head-variant="light"
              sticky-header
              hover
              responsive
              :items="listDevice"
              :fields="fieldsTableDevice"
              selectable
              show-empty
              select-mode="single"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
              <template #cell(index)="data">
                <div class="text-center">{{ data?.index + 1 }}</div>
              </template>
              <template #cell(serialDevice)="{ item }">
                <div>
                  <p>{{ item?.serialDevice }}</p>
                  <p>Mobile User: {{ item?.mobileUserStr }}</p>
                </div>
              </template>

              <template #cell(location)="{ item }">
                <div>
                  <p>
                    <span class="text-secondary">Tên điểm: </span>
                    <span>{{ item?.storeName }}</span>
                  </p>
                  <p>
                    <span class="text-secondary">Địa chỉ: </span>
                    <span>{{ item?.address }}</span>
                  </p>
                </div>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>
    <VueLoadingOverlay :active.sync="isLoading" :is-full-page="true" />
  </div>
</template>

<script>
  import { showMess } from '@/config/utils'
  import DetailInfo from '@/components/cskh/DetailInfo'
  import Config from '@/thirdParty/config'
  import TotalCountCheck from '@/components/cskh/Counts.vue'

  import { OderDetails, OderHistory, OderDevice } from '@/services/customer-support/order-contract'

  const fieldsTableHistory = [
    {
      key: 'dateTime',
      label: 'Thời gian',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'user',
      label: 'Người thực hiện',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'action',
      label: 'Loại hành động',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'description',
      label: 'Lý do',
      thStyle: 'min-width: 150px',
    },
  ]
  const fieldsTableDevice = [
    {
      key: 'index',
      label: 'STT',
      class: 'text-center',
    },
    {
      key: 'categoryName',
      label: 'Tên thiết bị',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'serialDevice',
      label: 'Serail thiết bị',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'location',
      label: 'ĐCNTT',
      thStyle: 'min-width: 150px',
    },
  ]

  const typeMapping = {
    EMPLOYEE: 'Nhân viên',
    MERCHANT: 'Merchant',
  }

  export default {
    components: { DetailInfo, TotalCountCheck },
    data() {
      return {
        // lấy config
        Config,
        typeMapping,
        fieldsTableHistory,
        fieldsTableDevice,

        // thông tin view detail
        infoData: {},
        listDevice: [],
        listHistory: [],
        totalCount: 0,

        // loading
        isLoading: false,

        // trạng thái
        listStatus: [
          { id: 'NEW', text: 'Mới tạo', bgColor: 'badge-primary' },
          { id: 'COMPLETED', text: 'Hoàn thành', bgColor: 'badge-success' },
          { id: 'CANCEL', text: 'Từ chối', bgColor: 'badge-danger' },
        ],

        // key detail
        keyNames: [
          { key: 'code', label: 'Mã phiếu' },
          { key: 'contractCode', label: 'Mã hợp đồng/ phụ lục' },
          { key: 'contractType', label: 'Loại phụ lục' },
          { key: 'reason', label: 'Lý do' },
          { key: 'sender', label: 'Đối tượng chuyển' },
          { key: 'receiver', label: 'Đối tượng nhận' },
          { key: 'status', label: 'Trạng thái' },
          { key: 'dateCreateContract', label: 'Ngày tạo phụ lục' },
          { key: 'dateApprove', label: 'Ngày duyệt/từ chối' },
          { key: 'createByName', label: 'Người tạo phụ lục' },
          { key: 'approveByName', label: 'Người duyệt/từ chối ' },
        ],
      }
    },

    computed: {
      orderId() {
        // Lấy id từ route params
        return this.$route.params.id
      },
      getReason() {
        return reason => {
          const mapReason = Config.listReasonAppendix.reduce((acc, cur) => {
            acc[cur.id] = cur
            return acc
          }, {})
          return mapReason[reason] || reason
        }
      },
      getStatusObj() {
        return status => {
          const mapStatus = this.listStatus?.reduce((acc, cur) => {
            acc[cur.id] = cur
            return acc
          }, {})
          return mapStatus[status] || { text: status || '', bgColor: '' }
        }
      },
      getSenderTypeText() {
        return type => {
          return typeMapping[type] || type
        }
      },
    },
    methods: {
      async loadData() {
        this.isLoading = true

        try {
          // Xử lý API OderDetails
          await this.fetchOrderDetails()
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        }

        try {
          // Xử lý API OderDevice
          await this.fetchDevices()
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        }

        try {
          // Xử lý API OderHistory
          await this.fetchHistory()
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },

      async fetchOrderDetails() {
        const response = await OderDetails({
          id: this.orderId,
        })
        this.infoData = response?.data || {}
      },

      async fetchDevices() {
        const response = await OderDevice({
          id: this.orderId,
        })
        this.listDevice = response?.data || []
        this.totalCount = response?.data?.length || 0
      },

      async fetchHistory() {
        const response = await OderHistory({
          id: this.orderId,
        })
        this.listHistory = response?.data || []
      },
    },
    created() {
      // Gọi loadData khi component được tạo

      if (this.orderId) {
        this.loadData()
      }
    },
  }
</script>

<style lang="scss" scoped>
  h1 {
    border-bottom: none;
  }

  .h1-strong {
    border-left: 3px solid #13569f !important;
    padding-left: 5px;
    font-size: larger;
  }

  .spinner-center {
    display: flex;
    justify-content: center;
  }

  .border-row {
    border-bottom: 2px dashed #edf1fa;
    display: flex;
  }

  .btn-class {
    background-color: #edf6ff;
  }

  .btn-class:hover {
    background-color: #007bff;
  }
  .history {
    .b-table-sticky-header {
      min-height: 32.5vh;
      max-height: 32vh;
    }
  }
</style>
